import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createInvoiceConfig } from 'api/invoiceConfig/createInvoiceConfig'
import { invoiceConfigKey } from './keys'

export const useCreateInvoiceConfigMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof createInvoiceConfig>[0]) =>
      createInvoiceConfig(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: invoiceConfigKey })
    },
  })
}
